import { setQualificationEnrolments } from './dispatchers';
import { dataMultiLoader } from '../../web/utilities/dataLoader';

export function initialise(dispatch) {
  const initialQualificationEnrolmentsDataObjects = dataMultiLoader(
    'redux-qualification-enrolments'
  );
  initialQualificationEnrolmentsDataObjects.map(
    (initialQualificationEnrolmentsData) => {
      return dispatch(
        setQualificationEnrolments(
          Object.values(initialQualificationEnrolmentsData)
        )
      );
    }
  );
}
